import { brandConfigQueryOptions } from '@client-info/features/insurancePolicy/hooks/useBrandingConfig';
import i18n from '@client-info/i18n/i18next';
import { createFileRoute } from '@tanstack/react-router';
import { FALLBACK_APP_NAME } from './-hooks';

export const Route = createFileRoute('/delete-account/')({
  // A failed config fetch falls back to the Safeture defaults in the page
  loader: ({ context: { client } }) =>
    client.ensureQueryData(brandConfigQueryOptions).catch(() => undefined),
  head: ({ loaderData }) => ({
    meta: [
      {
        title: i18n.t('deleteaccount.heading', {
          ns: 'common',
          appName: loaderData?.appName ?? FALLBACK_APP_NAME,
        }),
      },
    ],
  }),
});
